module.exports = __webpack_public_path__ + "static/media/wetlands4cities.dfc256a2.jpg";